import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import image1 from '../../assets/images/pages/article-6/1.jpg'
import image2 from '../../assets/images/pages/article-6/2.jpg'
import image3 from '../../assets/images/pages/article-6/3.jpg'
import { Articles } from '../../components/Article/Articles/Articles'
import { Feedback } from '../../components/Feedback/Feedback'
import { Footer } from '../../components/Footer/Footer'
import { Header } from '../../components/Header/Header'
import { BackButton } from '../../components/UI/BackButton/BackButton'
import styles from '../../pages/ArticlesPage/articlePage.module.scss'

export const ArticlePage6 = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <>
      <Header />
      <main className={`${styles.articlePage} ${styles.article1}`}>
        <section className={styles.articleIntro}>
          <BackButton url='/' />

          <h1>
            <b>За что именно платят жители современных жилых кварталов</b>
          </h1>

          <div className={styles.articleDescrImg}>
            <img src={image1} alt={''} />
          </div>

          <div className={styles.articleLead}>
            <p>
              Любой новый жилой комплекс&nbsp;&mdash; это современные стандарты
              качества, новые инженерные и&nbsp;технические решения,
              а&nbsp;также большие объемы инфраструктуры&nbsp;&mdash;
              благоустройства и&nbsp;социальных объектов. Возникает вопрос: кто
              и&nbsp;как всем этим управляет?
            </p>
            <p>
              Вместе с&nbsp;экспертами разбираемся, чем современные дома
              отличаются от&nbsp;советской застройки и&nbsp;домов 90-х.
              В&nbsp;чем особенности их&nbsp;эксплуатации, как управляющие
              компании поддерживают комфорт в&nbsp;жилых кварталах,
              и&nbsp;во&nbsp;сколько это сегодня обходится.
            </p>
          </div>
        </section>

        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>
            Чем отличаются современные жилые кварталы от&nbsp;домов старой
            постройки
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                В&nbsp;советское время о&nbsp;благоустройстве не&nbsp;думали.
                Старые кварталы проектировались без закрытой территории,
                о&nbsp;разнообразии зеленых насаждений даже
                не&nbsp;задумывались, игровые комплексы были компактными
                и&nbsp;менее оснащенными, а&nbsp;территория вокруг
                не&nbsp;улучшалась, отмечают в&nbsp;компании ПИК-Комфорт
                (управляющая компания, обслуживает более 2,9&nbsp;тыс. домов
                в&nbsp;11&nbsp;регионах).
              </p>
              <p>
                Сегодняшние жилые кварталы&nbsp;невозможны без разноплановых
                детских площадок из&nbsp;натуральных материалов, гипоаллергенных
                деревьев и&nbsp;кустарников в&nbsp;закрытых дворах без машин.
                Во&nbsp;многих проектах ПИК теперь размещаются{' '}
                <a href='/article/3' target='_blank'>
                  плейхабы (PlayHub)
                </a>{' '}
                - громадные игровые площадки, занимающие территорию целого дома.
                Все игровые пространства выполнены из&nbsp;натуральных
                материалов, кварцевого песка, трав или дерева.
                В&nbsp;современных кварталах устанавливают системы безопасности
                (управление доступом через приложение на&nbsp;телефоне, охрану),
                что создает ощущение комфорта и&nbsp;безопасности. Вся
                необходимая{' '}
                <a href='/article/1' target='_blank'>
                  инфраструктура
                </a>
                : магазины, кафе, поликлиники, школы и&nbsp;детские
                сады&nbsp;&mdash; также находится внутри&nbsp;жилых кварталов.
              </p>
              <p>
                &laquo;Сейчас в&nbsp;России строительство жилья ведется
                в&nbsp;том числе в&nbsp;соответствии с&nbsp;национальным
                проектом &laquo;Жилье и&nbsp;городская
                среда&raquo;,&nbsp;&mdash; говорит заместитель руководителя
                Службы сервиса Ассоциации управляющих организаций &laquo;Новое
                качество&raquo; Виктория Шакирьянова. По&nbsp;ее&nbsp;словам,
                строительство новых жилых кварталов происходит с&nbsp;учетом
                прогресса в&nbsp;сфере технологий, инженерных коммуникаций
                и&nbsp;строительных материалов. Их&nbsp;применение повышает
                энергоэффективность, увеличивает срок их&nbsp;службы,
                износоустойчивость материалов, а&nbsp;также позволяет создать
                красивый внешний вид. Также это позволяет сокращать потребление
                ресурсов и&nbsp;вложения в&nbsp;текущие и&nbsp;капитальные
                ремонты, отмечает эксперт.
              </p>
            </div>
          </div>

          <div className={styles.articleDescrImg}>
            <img src={image2} alt={''} />
          </div>
        </section>

        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>
            Технологии управления: как&nbsp;УК создает комфорт в&nbsp;жилом
            квартале
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                С&nbsp;первых дней после сдачи дома и&nbsp;в&nbsp;период
                заселения необходимо обеспечить инженерное и&nbsp;санитарное
                обслуживание дома. Далее жители принимают решение
                по&nbsp;управляющей компаний и&nbsp;составу услуг путем
                голосования на&nbsp;общих собраниях собственников.
              </p>
              <p>
                &laquo;Задача управляющей компании&nbsp;&mdash; организовать
                качественную среду для проживания новых жителей. УК&nbsp;должна
                поддерживать комфорт в&nbsp;местах отдыха, совершенствовать
                озеленение, сохранять архитектуру и&nbsp;внешний вид домов
                согласно концепции застройки,&nbsp;&mdash; отмечает генеральный
                директор компании ПИК-Комфорт Василий Левин,&nbsp;&mdash; важно,
                чтобы люди могли на&nbsp;протяжении долгих лет наслаждаться тем
                окружением и&nbsp;благоустройством, которое создал
                застройщик&raquo;.
              </p>
              <p>
                УК&nbsp;постоянно тестирует новые технологии, например, открытие
                шлагбаумов по&nbsp;автоматическому распознаванию номеру
                автомобиля собственника или роботизированные технологии
                в&nbsp;услугах клининга. Самым распространенным является
                приложение, через которое каждый житель получает актуальную
                информацию о&nbsp;состоянии дома, передает показания потребления
                ресурсов, пользуется услугами профильных мастеров бытовых услуг.
              </p>
              <p>
                Приложение также позволяет управлять дистанционным доступом
                на&nbsp;территории жилого комплекса, например, открывать
                шлагбаум для въезда на&nbsp;территорию, двери в&nbsp;подъезде
                для курьерской доставки или калитки во&nbsp;дворе в&nbsp;случае,
                если под рукой нет ключа. Это удобное решение для жителей,
                за&nbsp;которым стоит команда профессионалов поддерживающая
                работу технологий.
              </p>
              <p>
                В&nbsp;большинстве домов установлены системы цифрового дома,
                которые позволяют отслеживать состояние дома в&nbsp;режиме
                онлайн. Речь идет о&nbsp;видеонаблюдении на&nbsp;территории
                и&nbsp;в&nbsp;подъездах, оперативном реагировании
                на&nbsp;поломки оборудования, остановки лифтов и&nbsp;аварийные
                ситуации.
              </p>
            </div>
          </div>
        </section>

        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>
            Сколько стоит обслуживание жилого комплекса
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Обслуживание современного жилого квартала можно сравнить с
                обслуживанием автомобиля или собственной квартиры. Чтобы
                обеспечить комфортную жизнь люди привыкли вкладывать деньги в
                ежегодное техобслуживание и ремонт машины, в новую сантехнику,
                обновление мебели или декора в квартире. Комфортное
                времяпровождение на территории жилого квартала тоже требует
                вложений.
              </p>
            </div>
          </div>

          <div className={styles.articleDescrImg}>
            <img src={image3} alt={''} />
          </div>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Аналитики оценивают, что при среднем количестве квартир
                в&nbsp;домах, от&nbsp;1000 до&nbsp;1500 и&nbsp;площади около
                50&nbsp;тыс.&nbsp;кв.&nbsp;м, обслуживание дома обойдется около
                2,5 млн руб.&nbsp;в&nbsp;месяц или 30&nbsp;млн
                руб.&nbsp;в&nbsp;год.
              </p>
              <p>
                В&nbsp;УК&nbsp;ПИК-Комфорт подробно рассказали, на&nbsp;что
                именно расходуются деньги и&nbsp;какие услуги помогают
                поддерживать комфорт в&nbsp;современных домах:
              </p>
              <p>
                <b>Эксплуатация помещений включает</b> содержание и&nbsp;ремонт
                инженерных систем дома, лифтового оборудования, систем
                противопожарной безопасности и&nbsp;всех видов оборудования
                жизнеобеспечения дома.
              </p>
              <p>
                <b>Обеспечение чистоты и&nbsp;порядка</b> предполагает уборку
                мест общего пользования, входных групп, подъездов, фасадов
                зданий, во&nbsp;дворах, зонах отдыха и&nbsp;бульварах,
                паркингах. В&nbsp;зимний период дополнительно появляются работы
                по&nbsp;очистке территорий от&nbsp;снега и&nbsp;вывозу снега
                с&nbsp;территорий жилых комплексов.
              </p>
              <p>
                <b>Обслуживание дворов</b> включает комплекс работ
                по&nbsp;благоустройству и&nbsp;уходу за&nbsp;растениями
                и&nbsp;газонами, ремонту и&nbsp;содержанию малых архитектурных
                форм (беседки, лавочки, детские площадки, спортивные
                сооружения). Для этого, например, в&nbsp;составе команды
                ПИК-Комфорт есть дендрологи и&nbsp;ландшафтные дизайнеры.
              </p>
              <p>
                <b>Охрана территории обеспечивается</b> регулярным
                патрулированием домов, подъездов и&nbsp;прилегающих территорий,
                контролем общественного порядка и&nbsp;сохранности общедомового
                имущества и&nbsp;оборудования.
              </p>
              <p>
                Современные УК&nbsp;предоставляют более 150 наименований услуг,
                включая инженерные, сварочные, сантехнические работы, работы
                по&nbsp;мелкому бытовому ремонту, сборке мебели и&nbsp;установке
                домашнего оборудования.
              </p>
              <p>
                За&nbsp;30&nbsp;лет система управления домами стала более чуткой
                по&nbsp;отношению к&nbsp;потребителю. Компании стремятся создать
                комфортное пространство вокруг жилых домов.
              </p>
              <p>
                УК&nbsp;сегодня привлекают ландшафтных дизайнеров, инженеров
                и&nbsp;специалистов информационных технологий. Такая команда
                профессионалов способствует повышению качества жизни жителей
                и&nbsp;созданию уютной, ухоженной и&nbsp;безопасной среды
                проживания. Благодаря их&nbsp;усилиям, управляющая компания
                может предоставлять более качественную помощь жителям,решать
                проблемы дома совместно с&nbsp;ними и&nbsp;принимать важные
                решения, направленные на&nbsp;общее благо. Это позволяет
                поддерживать высокий уровень ухода за&nbsp;территорией
                и&nbsp;обеспечивать безопасность жителей. Кроме того,
                УК&nbsp;участвуют и&nbsp;в&nbsp;формировании социальной среды,
                проводят полезные развлекательные и&nbsp;образовательные
                программы для всех желающих.
              </p>
            </div>
          </div>
        </section>

        <section className={styles.articleContent}>
          <Articles excludeId='6' />
        </section>
        <Feedback />
      </main>
      <Footer />
    </>
  )
}
